export default "__VITE_ASSET__BsVLZqMJ__"